/* eslint-disable */
// this is autogenerated code (we do not care about the linter)

import * as Types from "./types.graphql-gen";

import { gql } from "apollo-angular";
import { Injectable } from "@angular/core";
import * as Apollo from "apollo-angular";
export type SignUpForForWeb3MigrationMutationVariables = Types.Exact<{ [key: string]: never }>;

export type SignUpForForWeb3MigrationMutation = {
	__typename?: "Mutation";
	signUpForWeb3Migration: {
		__typename?: "Web3MigrationSignUpResponse";
		code: number;
		web3Migration: { __typename?: "Web3MigrationStatus"; signedUp: boolean };
	};
};

export const SignUpForForWeb3MigrationDocument = gql`
	mutation signUpForForWeb3Migration {
		signUpForWeb3Migration {
			code
			web3Migration {
				signedUp
			}
		}
	}
`;

@Injectable({
	providedIn: "root"
})
export class SignUpForForWeb3MigrationGQLService extends Apollo.Mutation<
	SignUpForForWeb3MigrationMutation,
	SignUpForForWeb3MigrationMutationVariables
> {
	document = SignUpForForWeb3MigrationDocument;

	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
